<glxy-form-field [attr.data-testid]="'field-with-id-' + fieldId">
  <glxy-label>
    {{ label | translate }}
    <crm-sync-icon [fieldId]="fieldId"></crm-sync-icon>
  </glxy-label>
  <input
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    [placeholder]="'MODEL_DRIVEN_FORM.ADD_FIELD_VALUE' | translate: { fieldName: label?.toLowerCase() }"
    #textInput="matInput"
    maxlength="4000"
    id="{{ disableAutoComplete }}"
    name="{{ disableAutoComplete }}"
    autocomplete="{{ disableAutoComplete }}"
    [@autoFill]="autoFillState"
    (keydown.enter)="$event.preventDefault()"
    (focus)="initializeField()"
    (blur)="saveField()"
  />
  @if (control.value) {
  <button matSuffix mat-icon-button class="crm-field-clear-button" aria-label="Clear" (click)="clear()">
    <mat-icon>close</mat-icon>
  </button>
  }
  <mat-autocomplete #auto="matAutocomplete">
    @for (option of filteredOptions$ | async; track option) {
    <mat-option [value]="option" (mousedown)="$event.preventDefault()"> {{ option }} </mat-option>
    }
  </mat-autocomplete>
  @if(control.value?.length === 4000) {
  <glxy-error>
    {{ 'MODEL_DRIVEN_FORM.STRING_LIMIT_HINT' | translate: { characters: control.value?.length || 0 } }}
  </glxy-error>
  } @if (_control.hasError('invalidSocialMediaUrl')) {
  <glxy-error> {{ 'MODEL_DRIVEN_FORM.INVALID_URL_ERROR' | translate }} </glxy-error>
  }
</glxy-form-field>
